import { ComponentMultiStyleConfig } from '@chakra-ui/react';
import { StyleFunctionProps } from '@chakra-ui/theme-tools';

import { getFocusedOutlineShadow } from 'theme/shadows';

const SwitchTheme: ComponentMultiStyleConfig = {
  parts: ['container', 'track', 'thumb'],
  baseStyle: (props: StyleFunctionProps) => ({
    track: {
      boxShadow: 'inset 0px 1px 0px rgba(18, 21, 26, 0.04), inset 0px 0px 1px rgba(18, 21, 26, 0.08)',
      _dark: {
        bg: 'grey.light',

        _checked: {
          bg: 'blue.base'
        },

        _focus: {
          boxShadow: getFocusedOutlineShadow(props)
        },

        _disabled: {
          bg: 'black.lightest',
          opacity: 1,

          '.chakra-switch__thumb': {
            bg: 'grey.base'
          },

          _checked: {
            bg: 'blue.darkest',
            '.chakra-switch__thumb': {
              bg: 'blue.lighter'
            }
          }
        }
      },

      _light: {
        bg: 'grey.lightest',

        _checked: {
          bg: 'blue.base'
        },

        _focus: {
          boxShadow: getFocusedOutlineShadow(props)
        },

        _disabled: {
          bg: 'silver.base',
          opacity: 1,

          _checked: {
            bg: 'blue.lighter'
          }
        }
      }
    },
    thumb: {
      boxShadow: '0px 1px 0px rgba(18, 21, 26, 0.08), 0px 1px 1px rgba(18, 21, 26, 0.08)'
    },
    label: {
      _dark: {
        _disabled: {
          color: 'grey.base'
        }
      },
      _light: {
        _disabled: {
          color: 'grey.lighter'
        }
      }
    },
    container: {
      display: 'flex',
      alignItems: 'center'
    }
  }),
  sizes: {
    sm: {
      thumb: {
        w: '12px',
        h: '12px'
      },
      label: {
        fontSize: '12px'
      }
    },
    md: {
      thumb: {
        w: '16px',
        h: '16px'
      },
      label: {
        fontSize: '14px'
      }
    },
    lg: {
      thumb: {
        w: '24px',
        h: '24px'
      },
      label: {
        fontSize: '17px'
      }
    }
  },
  defaultProps: {}
};

export default SwitchTheme;
